import { gql } from 'graphql-request';
import { PayrollUpdateEmployeeVpfGraphQLRequest, PayrollUpdateEmployeeVpfResponse } from '../types';
import { graphQLApi } from 'utils/Api';

const updateEmployeeVpfMutation = gql`
  mutation PayrollUpdateEmployeeVpf($input: PayrollUpdateEmployeeVpfInput!) {
    payrollUpdateEmployeeVpf(input: $input) {
      code
      success
      message
      data {
        peopleId
        vpfAmount
      }
    }
  }
`;

const updateEmployeeVpf = (queryVariables: PayrollUpdateEmployeeVpfGraphQLRequest) => {
  return graphQLApi<PayrollUpdateEmployeeVpfResponse, PayrollUpdateEmployeeVpfGraphQLRequest>({
    query: updateEmployeeVpfMutation,
    queryVariables,
  });
};

export default updateEmployeeVpf;
